module.exports = __webpack_public_path__ + "img/learn-more.f6ef68dd.svg";